import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHandlers, useSite } from '../../../context/page-context';
import { METAFIELD_QUERY_KEY } from './use-metafield-configuration';

export function useEnableMetafield() {
  const { apis } = useHandlers();
  const site = useSite();
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>({
    mutationFn: (key) => apis.platform.enableMetafield(site.siteId, site.siteEnv, key),
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [METAFIELD_QUERY_KEY, site.siteId, site.siteEnv],
      });
    },
  });
}
